import React from 'react';
import DynaSelectBox from "../../DynaView/DynaSelectBox";

const TransferLearnerKol = ({initialData, setClassesId, classesId}) => {

  const Arrow = <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="17"
    fill="none"
    viewBox="0 0 15 17"
  >
    <path
      fill="#5A507B"
      d="M1.5 11.098c-2-1.155-2-4.041 0-5.196l9-5.196c2-1.155 4.5.288 4.5 2.598v10.392c0 2.31-2.5 3.753-4.5 2.598l-9-5.196z"
    ></path>
  </svg>

  return (
    <div className="transferLearnerKol">
      <div className={"transferPart"}>
        <div className={"title-side"}>
          {Arrow}
          <h4>انتخاب کلاس مبدا</h4>
        </div>

        <DynaSelectBox options={initialData}
                       hasFilter={true}
                       label={"جستجو"}
                       className={"solid-dyna-input"}
                       value={classesId?.origin}
                       onChange={(data) => {
                         if (data.value !== classesId?.destination) {
                           setClassesId({
                             ...classesId,
                             origin: data.value,
                             originName: data.label
                           })
                         }
                       }}/>

        {classesId?.origin !== "" &&
          <ul className={"show-class"}>
            <li className={"header-small"}>
              <h6 style={{width: '30%'}}>کد کلاس</h6>
              <h6 style={{width: '70%'}}>عنوان کلاس</h6>
            </li>
            <li>
              <h6 style={{width: '30%'}}>{classesId?.origin}</h6>
              <h6 style={{width: '70%'}}>{classesId?.originName}</h6>
            </li>
          </ul>
        }
      </div>
      <div className={"transferPart"}>
        <div className={"title-side"}>
          {Arrow}
          <h4>انتخاب کلاس مقصد</h4>
        </div>

        <DynaSelectBox options={initialData}
                       hasFilter={true}
                       label={"جستجو"}
                       className={"solid-dyna-input"}
                       value={classesId?.destination}
                       onChange={(data) => {
                         if (data.value !== classesId?.origin) {
                           setClassesId({
                             ...classesId,
                             destination: data.value,
                             destinationName: data.label
                           })
                         }
                       }}/>

        {classesId?.destination !== "" &&
          <ul className={"show-class"}>
            <li className={"header-small"}>
              <h6 style={{width: '30%'}}>کد کلاس</h6>
              <h6 style={{width: '70%'}}>عنوان کلاس</h6>
            </li>
            <li>
              <h6 style={{width: '30%'}}>{classesId?.destination}</h6>
              <h6 style={{width: '70%'}}>{classesId?.destinationName}</h6>
            </li>
          </ul>
        }
      </div>
    </div>
  );
};

export default TransferLearnerKol;